import { buildLastLoginMethodPayload, } from './buildLastLoginMethodPayload.js';
export const trackLastLoginMethodVisibility = (params) => buildLastLoginMethodPayload(params);
//# sourceMappingURL=trackLastLoginMethodVisibility.js.map